module.exports = __webpack_public_path__ + "static/media/nodataGreen.ab500b96.png";